<template>
  <div class="dates-title semibold">
    <div class="dates-title__title">
      <span v-html="calendar" class="mb-1"></span>
      <span> Andata: {{ formatted_date(departure_date) }} </span>
      <span v-if="return_date" style="font-size: 40px; line-height: 0"> &middot; </span>
      <span v-if="return_date"> Ritorno: {{ formatted_date(return_date) }} </span>
    </div>
    <btn-back />
  </div>
</template>

<script>
import { calendar } from '@/components/svg/flight';
import { reverse_date, parse_flight_offers_date } from '@/utilities';
import { get_flight_offer_dates } from '@/flight-offer';
import BtnBack from '@/components/atoms/btn-back';

export default {
  name: 'dates-title',
  components: {
    'btn-back': BtnBack,
  },
  props: {
    flight_offer: Object,
  },
  data() {
    return {
      calendar,
    };
  },
  methods: {
    reverse_date,
    parse_flight_offers_date,
    get_flight_offer_dates,
    formatted_date(date) {
      return this.reverse_date(this.parse_flight_offers_date(date.at).day);
    },
  },
  computed: {
    departure_date() {
      return this.get_flight_offer_dates(this.flight_offer).departure;
    },
    return_date() {
      return this.get_flight_offer_dates(this.flight_offer).return;
    },
  },
};
</script>

<style lang="scss" scoped>
.dates-title {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 20px;
  padding-left: 10px;
  &__title {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 20px;
    gap: 10px;

    @include media-breakpoint-down(md) {
      font-size: 16px;
      gap: 5px;
    }
  }
}
</style>
